import { BitmapText, Container, ContainerOptions, Graphics } from "pixi.js";

export interface StaticSymbolOptions extends ContainerOptions {
  fontFamily: string;
  fontSize: number;
  tint?: number;
  char: string;
}

export class StaticSymbol extends Container {
  private readonly symbolText: BitmapText;

  // private _debugGfx: Graphics = new Graphics();

  constructor(options: StaticSymbolOptions) {
    super(options);

    // this.addChild(this._debugGfx);

    this.symbolText = new BitmapText({
      text: options.char,
      style: {
        fontFamily: options.fontFamily,
        fontSize: options.fontSize,
      },
    });

    if (options.tint !== undefined) {
      this.symbolText.tint = options.tint;
    }

    // Center the symbol the same way digits are centered: anchor (0.5, 0.5)
    // with an explicit offset of half its own dimensions so the font's
    // internal baseLineOffset cancels out identically to the digit column.
    this.symbolText.anchor.set(0.5, 0.5);
    this.symbolText.x = this.symbolText.width / 2;
    this.symbolText.y = this.symbolText.height / 2;
    this.addChild(this.symbolText);

    // this._debugGfx
    //   .rect(
    //     -this.symbolText.width * this.symbolText._anchor.x,
    //     0,
    //     this.symbolText.width,
    //     this.symbolText.height,
    //   )
    //   .fill({
    //     color: "0x0000ffcc",
    //   });
  }

  public getSymbolWidth(): number {
    // Special handling for space character
    // Use the exact xadvance value from Faustina.fnt (131 pixels)
    const spaceXAdvance = 131 * 0.3; // From Faustina.fnt: char id=32 xadvance=131
    const spaceCount = (this.symbolText.text.match(/ /g) || []).length;

    if (spaceCount > 0) {
      // Add the exact xadvance for each space character
      return this.symbolText.width + spaceCount * spaceXAdvance;
    }

    return this.symbolText.width;
  }

  public getSymbolHeight(): number {
    return this.symbolText.height;
  }
}
